import { render, staticRenderFns } from "./taxi-course-segment-kilometer-alert.vue?vue&type=template&id=694a61a3"
import script from "./taxi-course-segment-kilometer-alert.vue?vue&type=script&lang=js"
export * from "./taxi-course-segment-kilometer-alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports